import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import camelCase from 'lodash/camelCase'
import { useWatch } from 'react-hook-form'

import FormItem from 'components/Form/Item'
import InputNumber from 'components/Form/InputNumber'

import { formatErrorMessage } from 'helpers/contactRequestForm'

const mapStateToProps = (state, ownProps) => ({
  initialValue: ownProps.initialValue || state.providersFilter.filters.guestCount,
})

const EventGuests = (props) => {
  const {
    intl,
    showError,
    initialValue,
    room,
  } = props

  const roomType = useWatch({ name: 'roomType' })

  return (
    <FormItem
      name="numberOfPersons"
      showError={showError}
      label={`${intl.formatMessage({ id: 'contactRequestForm.numberOfPersons' })}*`}
    >
      <InputNumber
        name="numberOfPersons"
        defaultValue={initialValue}
        rules={{
          required: formatErrorMessage(intl, 'numberOfPersonsCount'),
          pattern: {
            value: /^[1-9]\d*$/,
            message: formatErrorMessage(intl, 'numberOfPersonsCount', 'invalid'),
          },
          validator: (value) => {
            const capacity = room?.[camelCase(roomType)]

            if (value && capacity && value > capacity) {
              return intl.formatMessage(
                { id: 'contactRequestForm.errors.maximumCapacity' },
                { capacity: capacity },
              )
            }

            return true
          },
          deps: ['roomType'],
        }}
        className="contact-request-form__number-of-persons"
        min={0}
      />
    </FormItem>
  )
}

EventGuests.propTypes = {
  intl: PropTypes.object.isRequired,
  showError: PropTypes.bool,
  initialValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  room: PropTypes.object,
}

export default injectIntl(connect(mapStateToProps)(EventGuests))
